import { useEffect } from 'react';

import clsx from 'clsx';

import Button from 'components/Button';
import { useUserAuthDialog } from 'components/UserAuthDialog';
import { addEvent, sendEvent } from 'lib/AnalyticsGDM/analytics';
import { buildAccountEmailAuthEvent } from 'shared-utils/accountEmailEvents';

import classes from './AuthButtons.module.scss';

/** @type {import("./types").default} */
const AuthButtons = ({ className, colorVariant, ...props }) => {
  const [UserAuthDialog, openUserAuthDialog] = useUserAuthDialog({
    origin: 'header',
  });
  const colorVariantClass = `is-${colorVariant}`;

  useEffect(() => {
    sendEvent(buildAccountEmailAuthEvent('form-cta-impression', false));
  }, []);

  const handleAuthClick = () => {
    sendEvent(buildAccountEmailAuthEvent('form-cta-click', false));
    openUserAuthDialog({ selectedVariant: 'join' });
  };

  return (
    <div className={clsx('AuthButtons', classes.root, className)} {...props}>
      <UserAuthDialog />
      <Button
        data-testid="app_bar-join_or_login"
        {...addEvent({
          engagementComponent: 'header',
          engagementDestination: 'go-to_join-or-login',
          engagementDetails: 'button_join-or-login',
          name: 'login_cta',
        })}
        onClick={handleAuthClick}
        className={clsx(
          classes.button,
          classes.authButton,
          classes[colorVariantClass]
        )}
        variant="outlined"
      >
        Join or Log in
      </Button>
    </div>
  );
};
export default AuthButtons;
